var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('m-base',[_c('div',{staticClass:"content"},[_c('div',{staticClass:"reach"},[_c('div',[_c('h1',{staticClass:"title"},[_vm._v("Saved Lists ")])]),_vm._v(" "),_c('div',[_vm._v("Manage your recent saved lists to modify and prepare for checkout.")]),_vm._v(" "),_c('m-save-list-count')],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-39fd9c7f","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/saveListCount.vue
// module id = null
// module chunks = 